// v2.8 QoL: Card Discovery Journal — track SEEN / PLAYED / UPGRADED locally per player.
// Stored in localStorage.friendslop.cardStats as { [baseId]: { seen, played, upgraded } }.
// Upgraded (+) variants collapse to the base id so counts stay meaningful.

export function readCardStats() {
  try { return JSON.parse(localStorage.getItem('friendslop.cardStats') || '{}'); } catch (e) { return {}; }
}

export function writeCardStats(stats) {
  try { localStorage.setItem('friendslop.cardStats', JSON.stringify(stats)); } catch (e) {}
}

export function bumpCardStat(id, kind /* 'seen' | 'played' | 'upgraded' */) {
  if (!id) return;
  const base = String(id).replace(/\+$/, '');
  const stats = readCardStats();
  stats[base] = stats[base] || { seen: 0, played: 0, upgraded: 0 };
  stats[base][kind] = (stats[base][kind] || 0) + 1;
  writeCardStats(stats);
}
